export const AMM_CurrencyWithLocale = [
  {
    'amm_currency': 'AED',
    'amm_currency_locale': 'ar-AE',
  },
  {
    'amm_currency': 'AFN',
    'amm_currency_locale': 'fa-AF',
  },
  {
    'amm_currency': 'ALL',
    'amm_currency_locale': 'sq-AL',
  },
  {
    'amm_currency': 'AMD',
    'amm_currency_locale': 'hy-AM',
  },
  {
    'amm_currency': 'AOA',
    'amm_currency_locale': 'pt-AO',
  },
  {
    'amm_currency': 'ARS',
    'amm_currency_locale': 'es-AR',
  },
  {
    'amm_currency': 'AUD',
    'amm_currency_locale': 'en-AU',
  },
  {
    'amm_currency': 'AZN',
    'amm_currency_locale': 'az-AZ',
  },
  {
    'amm_currency': 'BAM',
    'amm_currency_locale': 'bs-BA',
  },
  {
    'amm_currency': 'BBD',
    'amm_currency_locale': 'en-BB',
  },
  {
    'amm_currency': 'BDT',
    'amm_currency_locale': 'bn-BD',
  },
  {
    'amm_currency': 'BGN',
    'amm_currency_locale': 'bg-BG',
  },
  {
    'amm_currency': 'BHD',
    'amm_currency_locale': 'ar-BH',
  },
  {
    'amm_currency': 'BIF',
    'amm_currency_locale': 'fr-BI',
  },
  {
    'amm_currency': 'BMD',
    'amm_currency_locale': 'en-BM',
  },
  {
    'amm_currency': 'BND',
    'amm_currency_locale': 'ms-BN',
  },
  {
    'amm_currency': 'BOB',
    'amm_currency_locale': 'es-BO',
  },
  {
    'amm_currency': 'BRL',
    'amm_currency_locale': 'pt-BR',
  },
  {
    'amm_currency': 'BSD',
    'amm_currency_locale': 'en-BS',
  },
  {
    'amm_currency': 'BTN',
    'amm_currency_locale': 'dz-BT',
  },
  {
    'amm_currency': 'BWP',
    'amm_currency_locale': 'en-BW',
  },
  {
    'amm_currency': 'BYN',
    'amm_currency_locale': 'be-BY',
  },
  {
    'amm_currency': 'BZD',
    'amm_currency_locale': 'en-BZ',
  },
  {
    'amm_currency': 'CAD',
    'amm_currency_locale': 'en-CA',
  },
  {
    'amm_currency': 'CDF',
    'amm_currency_locale': 'fr-CD',
  },
  {
    'amm_currency': 'CHF',
    'amm_currency_locale': 'de-CH',
  },
  {
    'amm_currency': 'CLP',
    'amm_currency_locale': 'es-CL',
  },
  {
    'amm_currency': 'CNH',
    'amm_currency_locale': 'zh-CN',
  },
  {
    'amm_currency': 'CNY',
    'amm_currency_locale': 'zh-CN',
  },
  {
    'amm_currency': 'COP',
    'amm_currency_locale': 'es-CO',
  },
  {
    'amm_currency': 'CRC',
    'amm_currency_locale': 'es-CR',
  },
  {
    'amm_currency': 'CVE',
    'amm_currency_locale': 'pt-CV',
  },
  {
    'amm_currency': 'CZK',
    'amm_currency_locale': 'cs-CZ',
  },
  {
    'amm_currency': 'DJF',
    'amm_currency_locale': 'fr-DJ',
  },
  {
    'amm_currency': 'DKK',
    'amm_currency_locale': 'da-DK',
  },
  {
    'amm_currency': 'DOP',
    'amm_currency_locale': 'es-DO',
  },
  {
    'amm_currency': 'DZD',
    'amm_currency_locale': 'ar-DZ',
  },
  {
    'amm_currency': 'EGP',
    'amm_currency_locale': 'ar-EG',
  },
  {
    'amm_currency': 'ERN',
    'amm_currency_locale': 'ti-ER',
  },
  {
    'amm_currency': 'ETB',
    'amm_currency_locale': 'am-ET',
  },
  {
    'amm_currency': 'EUR',
    'amm_currency_locale': 'de-DE',
  },
  {
    'amm_currency': 'FJD',
    'amm_currency_locale': 'en-FJ',
  },
  {
    'amm_currency': 'GBP',
    'amm_currency_locale': 'en-GB',
  },
  {
    'amm_currency': 'GEL',
    'amm_currency_locale': 'ka-GE',
  },
  {
    'amm_currency': 'GHS',
    'amm_currency_locale': 'en-GH',
  },
  {
    'amm_currency': 'GIP',
    'amm_currency_locale': 'en-GI',
  },
  {
    'amm_currency': 'GMD',
    'amm_currency_locale': 'en-GM',
  },
  {
    'amm_currency': 'GNF',
    'amm_currency_locale': 'fr-GN',
  },
  {
    'amm_currency': 'GTQ',
    'amm_currency_locale': 'es-GT',
  },
  {
    'amm_currency': 'GYD',
    'amm_currency_locale': 'en-GY',
  },
  {
    'amm_currency': 'HKD',
    'amm_currency_locale': 'zh-HK',
  },
  {
    'amm_currency': 'HNL',
    'amm_currency_locale': 'es-HN',
  },
  {
    'amm_currency': 'HRK',
    'amm_currency_locale': 'hr-HR',
  },
  {
    'amm_currency': 'HTG',
    'amm_currency_locale': 'fr-HT',
  },
  {
    'amm_currency': 'HUF',
    'amm_currency_locale': 'hu-HU',
  },
  {
    'amm_currency': 'IDR',
    'amm_currency_locale': 'id-ID',
  },
  {
    'amm_currency': 'ILS',
    'amm_currency_locale': 'he-IL',
  },
  {
    'amm_currency': 'INR',
    'amm_currency_locale': 'en-IN',
  },
  {
    'amm_currency': 'IQD',
    'amm_currency_locale': 'ar-IQ',
  },
  {
    'amm_currency': 'ISK',
    'amm_currency_locale': 'is-IS',
  },
  {
    'amm_currency': 'JMD',
    'amm_currency_locale': 'en-JM',
  },
  {
    'amm_currency': 'JOD',
    'amm_currency_locale': 'ar-JO',
  },
  {
    'amm_currency': 'JPY',
    'amm_currency_locale': 'ja-JP',
  },
  {
    'amm_currency': 'KES',
    'amm_currency_locale': 'en-KE',
  },
  {
    'amm_currency': 'KGS',
    'amm_currency_locale': 'ky-KG',
  },
  {
    'amm_currency': 'KHR',
    'amm_currency_locale': 'km-KH',
  },
  {
    'amm_currency': 'KMF',
    'amm_currency_locale': 'fr-KM',
  },
  {
    'amm_currency': 'KRW',
    'amm_currency_locale': 'ko-KR',
  },
  {
    'amm_currency': 'KTS',
    'amm_currency_locale': 'en-US',
  },
  {
    'amm_currency': 'KWD',
    'amm_currency_locale': 'ar-KW',
  },
  {
    'amm_currency': 'KYD',
    'amm_currency_locale': 'en-KY',
  },
  {
    'amm_currency': 'KZT',
    'amm_currency_locale': 'kk-KZ',
  },
  {
    'amm_currency': 'LAK',
    'amm_currency_locale': 'lo-LA',
  },
  {
    'amm_currency': 'LBP',
    'amm_currency_locale': 'ar-LB',
  },
  {
    'amm_currency': 'LKR',
    'amm_currency_locale': 'si-LK',
  },
  {
    'amm_currency': 'LRD',
    'amm_currency_locale': 'en-LR',
  },
  {
    'amm_currency': 'LSL',
    'amm_currency_locale': 'en-LS',
  },
  {
    'amm_currency': 'LYD',
    'amm_currency_locale': 'ar-LY',
  },
  {
    'amm_currency': 'MAD',
    'amm_currency_locale': 'ar-MA',
  },
  {
    'amm_currency': 'MDL',
    'amm_currency_locale': 'ro-MD',
  },
  {
    'amm_currency': 'MGA',
    'amm_currency_locale': 'fr-MG',
  },
  {
    'amm_currency': 'MKD',
    'amm_currency_locale': 'mk-MK',
  },
  {
    'amm_currency': 'MMK',
    'amm_currency_locale': 'my-MM',
  },
  {
    'amm_currency': 'MNT',
    'amm_currency_locale': 'mn-MN',
  },
  {
    'amm_currency': 'MOP',
    'amm_currency_locale': 'zh-MO',
  },
  {
    'amm_currency': 'MRU',
    'amm_currency_locale': 'ar-MR',
  },
  {
    'amm_currency': 'MUR',
    'amm_currency_locale': 'en-MU',
  },
  {
    'amm_currency': 'MVR',
    'amm_currency_locale': 'dv-MV',
  },
  {
    'amm_currency': 'MWK',
    'amm_currency_locale': 'en-MW',
  },
  {
    'amm_currency': 'MXN',
    'amm_currency_locale': 'es-MX',
  },
  {
    'amm_currency': 'MYR',
    'amm_currency_locale': 'ms-MY',
  },
  {
    'amm_currency': 'MZN',
    'amm_currency_locale': 'pt-MZ',
  },
  {
    'amm_currency': 'NAD',
    'amm_currency_locale': 'en-NA',
  },
  {
    'amm_currency': 'NGN',
    'amm_currency_locale': 'en-NG',
  },
  {
    'amm_currency': 'NIO',
    'amm_currency_locale': 'es-NI',
  },
  {
    'amm_currency': 'NOK',
    'amm_currency_locale': 'nb-NO',
  },
  {
    'amm_currency': 'NPR',
    'amm_currency_locale': 'ne-NP',
  },
  {
    'amm_currency': 'NZD',
    'amm_currency_locale': 'en-NZ',
  },
  {
    'amm_currency': 'OMR',
    'amm_currency_locale': 'ar-OM',
  },
  {
    'amm_currency': 'PAB',
    'amm_currency_locale': 'es-PA',
  },
  {
    'amm_currency': 'PEN',
    'amm_currency_locale': 'es-PE',
  },
  {
    'amm_currency': 'PGK',
    'amm_currency_locale': 'en-PG',
  },
  {
    'amm_currency': 'PHP',
    'amm_currency_locale': 'en-PH',
  },
  {
    'amm_currency': 'PKR',
    'amm_currency_locale': 'ur-PK',
  },
  {
    'amm_currency': 'PLN',
    'amm_currency_locale': 'pl-PL',
  },
  {
    'amm_currency': 'PYG',
    'amm_currency_locale': 'es-PY',
  },
  {
    'amm_currency': 'QAR',
    'amm_currency_locale': 'ar-QA',
  },
  {
    'amm_currency': 'RON',
    'amm_currency_locale': 'ro-RO',
  },
  {
    'amm_currency': 'RSD',
    'amm_currency_locale': 'sr-RS',
  },
  {
    'amm_currency': 'RUB',
    'amm_currency_locale': 'ru-RU',
  },
  {
    'amm_currency': 'RWF',
    'amm_currency_locale': 'rw-RW',
  },
  {
    'amm_currency': 'SAR',
    'amm_currency_locale': 'ar-SA',
  },
  {
    'amm_currency': 'SBD',
    'amm_currency_locale': 'en-SB',
  },
  {
    'amm_currency': 'SCR',
    'amm_currency_locale': 'en-SC',
  },
  {
    'amm_currency': 'SEK',
    'amm_currency_locale': 'sv-SE',
  },
  {
    'amm_currency': 'SGD',
    'amm_currency_locale': 'en-SG',
  },
  {
    'amm_currency': 'SLE',
    'amm_currency_locale': 'en-SL',
  },
  {
    'amm_currency': 'SRD',
    'amm_currency_locale': 'nl-SR',
  },
  {
    'amm_currency': 'SZL',
    'amm_currency_locale': 'en-SZ',
  },
  {
    'amm_currency': 'THB',
    'amm_currency_locale': 'th-TH',
  },
  {
    'amm_currency': 'TMT',
    'amm_currency_locale': 'tk-TM',
  },
  {
    'amm_currency': 'TND',
    'amm_currency_locale': 'ar-TN',
  },
  {
    'amm_currency': 'TOP',
    'amm_currency_locale': 'to-TO',
  },
  {
    'amm_currency': 'TRY',
    'amm_currency_locale': 'tr-TR',
  },
  {
    'amm_currency': 'TTD',
    'amm_currency_locale': 'en-TT',
  },
  {
    'amm_currency': 'TWD',
    'amm_currency_locale': 'zh-TW',
  },
  {
    'amm_currency': 'TZS',
    'amm_currency_locale': 'sw-TZ',
  },
  {
    'amm_currency': 'UAH',
    'amm_currency_locale': 'uk-UA',
  },
  {
    'amm_currency': 'UGX',
    'amm_currency_locale': 'en-UG',
  },
  {
    'amm_currency': 'USD',
    'amm_currency_locale': 'en-US',
  },
  {
    'amm_currency': 'UYU',
    'amm_currency_locale': 'es-UY',
  },
  {
    'amm_currency': 'UZS',
    'amm_currency_locale': 'uz-UZ',
  },
  {
    'amm_currency': 'VES',
    'amm_currency_locale': 'es-VE',
  },
  {
    'amm_currency': 'VND',
    'amm_currency_locale': 'vi-VN',
  },
  {
    'amm_currency': 'VUV',
    'amm_currency_locale': 'en-VU',
  },
  {
    'amm_currency': 'WST',
    'amm_currency_locale': 'en-WS',
  },
  {
    'amm_currency': 'XAF',
    'amm_currency_locale': 'fr-CM',
  },
  {
    'amm_currency': 'XCD',
    'amm_currency_locale': 'en-AG',
  },
  {
    'amm_currency': 'XCG',
    'amm_currency_locale': 'en-CW',
  },
  {
    'amm_currency': 'XOF',
    'amm_currency_locale': 'fr-SN',
  },
  {
    'amm_currency': 'XPF',
    'amm_currency_locale': 'fr-PF',
  },
  {
    'amm_currency': 'YER',
    'amm_currency_locale': 'ar-YE',
  },
  {
    'amm_currency': 'YUM',
    'amm_currency_locale': 'sr-RS',
  },
  {
    'amm_currency': 'ZAR',
    'amm_currency_locale': 'en-ZA',
  },
  {
    'amm_currency': 'ZMW',
    'amm_currency_locale': 'en-ZM',
  },
];